import { useChatStatus } from '@ai-sdk-tools/store';
import { MessageBox } from '@newfront-insurance/core-ui';
import { motion } from 'framer-motion';

import { useChatOverlayContextSafe } from '../contexts/chat-overlay-context';

const DEFAULT_ERROR_MESSAGE = 'There was an error with your request. Please try again.';

/**
 * Displays a hardcoded error message inline when the chat status is 'error'.
 * The message can be overridden via the errorMessage prop on NovaProvider.
 */
export function InlineError() {
  const status = useChatStatus();
  const overlayContext = useChatOverlayContextSafe();

  if (status !== 'error') {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className="mx-auto w-full max-w-3xl px-2"
    >
      <MessageBox
        variant="alert"
        message={overlayContext?.errorMessage || DEFAULT_ERROR_MESSAGE}
        boxClassName="border-fire-500"
        textClassName="text-fire-500"
      />
    </motion.div>
  );
}
